export default {
    namespaced: true,
    state: () => ({
        popup: false,
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        openPopup ({ commit }) {
            commit('setPopup', true)
        },
        closePopup ({ commit }) {
            commit('setPopup', false)
        }
    },
    mutations: {
        setPopup (state, bool) {
            state.popup = bool
        }
    }
}
